import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Platform} from 'react-native';

const BackHandler =
  Platform.OS === 'android' ? require('react-native').BackHandler : null;

import {
  BottomTabButton,
  BottomTab,
} from 'src/Modules/TabViews/FooterComponents';

import CopilottedView from 'src/Modules/CommonView/CopilottedView.js';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {updateHomeState} from '../Redux/reducers/home.reducer';
import {updateLocalView} from '../Redux/reducers/local.reducer';

const DrawerTab = () => {
  console.log('drawer tab rerender');
  const dispatch = useDispatch();

  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const hasPressedPrizes = useSelector(
    (state) => state.firstVisit.hasPressedPrizes,
  );

  const customAdView = useSelector((state) => state.user?.customAdView);

  const buttonStyle = {marginTop: 5, maxWidth: '25%'};

  useEffect(() => {
    var backHandler;
    if (BackHandler && Platform.OS == 'android') {
      backHandler = BackHandler?.addEventListener?.('hardwareBackPress', () => {
        navigationRef.navigate('LandingPage');
        return true;
      });
    }
    return () => backHandler?.remove?.();
  }, []);

  return (
    <BottomTab height={70} tabStyle={{alignItems: 'flex-start'}}>
      <BottomTabButton
        text={'Activities'}
        iconName={'directions'}
        handlePress={() => {
          navigationRef.navigate('LandingPage');

          dispatch(
            updateHomeState({
              homeView: 'list',
              homeActiveSearch: null,
              homeSearchText: null,
            }),
          );
        }}
        buttonStyle={buttonStyle}
        activeScreenName={'LandingPage'}
      />
      {!window?.location?.href?.includes?.('isDemo') && (
        <CopilottedView
          text="Explore local sites any time with our free local guide. Explore 1000+ curated locations."
          order={4}
          name="LOCAL_GUIDE">
          <BottomTabButton
            text={'Local Guide'}
            iconName={'map'}
            handlePress={() => {
              dispatch(updateLocalView('list'));
              navigationRef.navigate('LocalTab');
            }}
            buttonStyle={buttonStyle}
            activeScreenName={'Local'}
          />
        </CopilottedView>
      )}

      {playTestState == false &&
        Platform.OS != 'web' &&
        !window?.location?.href?.includes?.('isDemo') && (
          <CopilottedView
            text="Ready to win? Access your Daily Challenges here. Earn badges, coins and prizes!"
            order={5}
            name="Prizes">
            <BottomTabButton
              text={'Prizes'}
              testID={'prizes'}
              iconName={'badge'}
              handlePress={() => {
                navigationRef.navigate('Community');
                if (!hasPressedPrizes && !customAdView) {
                  navigationRef.navigate('PrizeWheelModal');
                }
              }}
              buttonStyle={buttonStyle}
              activeScreenName={'Community'}
              badge={!hasPressedPrizes ? 1 : false}
            />
          </CopilottedView>
        )}

      <CopilottedView
        text="Let’s go! Join an event set up by friends/family/co-workers or redeem your Let’s Roam voucher here."
        order={3}
        name="Join">
        <BottomTabButton
          text={'Join'}
          iconName={'people'}
          handlePress={() => {
            console.log('JoinLanding Pressed');
            navigationRef.navigate('JoinLanding');
          }}
          testID={'joinCodeTabButton'}
          buttonStyle={buttonStyle}
          activeScreenName={'JoinLanding'}
        />
      </CopilottedView>
    </BottomTab>
  );
};

export default DrawerTab;
